import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api/v1';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to every request if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Do not redirect if the failed request was the login attempt itself
      const requestUrl = error.config?.url || '';
      if (!requestUrl.includes('/auth/login')) {
        // Clear local storage and redirect to login if token is invalid or expired
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location = '/login';
      }
    }
    if (error.response && error.response.status === 403) {
      const detail = error.response.data?.detail;
      const code = typeof detail === 'object' ? detail?.code : null;
      if (code === 'ACCOUNT_EXPIRED' || code === 'ACCOUNT_LOCKED') {
        const requestUrl = error.config?.url || '';
        if (!requestUrl.includes('/auth/login')) {
          const msg = typeof detail === 'object' && detail?.message
            ? detail.message
            : (code === 'ACCOUNT_EXPIRED'
                ? 'Tài khoản học viên của bạn đã hết hạn sử dụng. Vui lòng liên hệ trung tâm để được gia hạn!'
                : 'Tài khoản học viên của bạn đang bị khóa. Vui lòng liên hệ trung tâm!');
          sessionStorage.setItem('sv_auth_notice', msg);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location = `/login?reason=${code.toLowerCase()}`;
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
